import { Alert, Button, Chip, Stack, Typography } from '@mui/material';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import { useImpersonation } from '../../hooks/useImpersonation';

/**
 * Banner zobrazeny pouze SUPER_ADMINovi v admin sekci pokud je `?unitId=X` v URL.
 * Umozni ukoncit impersonation a vratit se na /superadmin.
 */
export const ImpersonationBanner = () => {
  const { isImpersonating, impersonatedUnit } = useImpersonation();
  const navigate = useNavigate();

  if (!isImpersonating) return null;

  const isInactive = impersonatedUnit ? !impersonatedUnit.isActive : false;

  return (
    <Alert
      severity={isInactive ? 'warning' : 'info'}
      icon={<SupervisorAccountIcon />}
      sx={{
        mb: 2,
        borderLeft: 4,
        borderColor: isInactive ? 'warning.main' : 'primary.main',
      }}
      action={
        <Button
          size="small"
          color="inherit"
          startIcon={<CloseIcon />}
          onClick={() => navigate('/superadmin')}
        >
          Ukončit
        </Button>
      }
    >
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems={{ sm: 'center' }}>
        <Typography variant="body2" fontWeight={600}>
          Administrujete jednotku:
        </Typography>
        <Typography variant="body2">{impersonatedUnit?.name ?? '…'}</Typography>
        {isInactive && <Chip size="small" color="warning" label="Deaktivovaná" />}
      </Stack>
    </Alert>
  );
};
